import { CodeBlock, CodeBlockCopyButton } from "@/components/ai-elements/code-block";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslation } from "@/hooks/useTranslation";

export const DialogAdditionalData = ({
  additionalData,
  open,
  onClose,
}: {
  additionalData: any;
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-auto">
        <DialogHeader>
          <DialogTitle>
            {t(
              "admin.dataTableAdminTeams.dialogs.giftCredits.history.additionalData.title"
            )}
          </DialogTitle>
        </DialogHeader>
        <div className="overflow-auto mt-4 max-h-[60vh]">
          <CodeBlock
            code={JSON.stringify(additionalData, null, 2)}
            language="json"
          >
            <CodeBlockCopyButton />
          </CodeBlock>
        </div>
      </DialogContent>
    </Dialog>
  );
};
